export const environment = {
    BASE_WS_URL: 'api'
};